import { PipeTransform } from '@angular/core';
var TextFormatterPipe = /** @class */ (function () {
    function TextFormatterPipe() {
    }
    TextFormatterPipe.prototype.transform = function (text, options) {
        if (options === void 0) { options = undefined; }
        var transformedText = this.handleDynamoWarning(text);
        if (options) {
            transformedText = this.handleOptions(transformedText, options);
        }
        return transformedText;
    };
    TextFormatterPipe.prototype.handleOptions = function (transformedText, options) {
        var answer = transformedText;
        if (options.prefix) {
            answer = "" + options.prefix + transformedText;
        }
        return answer;
    };
    TextFormatterPipe.prototype.handleDynamoWarning = function (text) {
        // Get position of a special character that
        // Dynamo sends with each warning message
        var startPosition = text.indexOf('/') + 1;
        // Return a clean warning message
        return text.substring(startPosition);
    };
    return TextFormatterPipe;
}());
export { TextFormatterPipe };
